// userSlice.js
import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    isAuthenticated: !!localStorage.getItem("token"), // Default: true if token exists
    user: null,
  },
  reducers: {
    setLogin(state, action) {
      state.isAuthenticated = true;
      state.user = action.payload;
    },
    setUserProfile(state, action) {
      state.isAuthenticated = true;
      state.user = action.payload;
    },
    logout(state) {
      state.isAuthenticated = false;
      state.user = null;
      localStorage.removeItem("token");
      localStorage.removeItem("token_expiry");
      localStorage.removeItem("pos_id");
    },
  },
});

export const { setLogin, logout,setUserProfile } = userSlice.actions;
export default userSlice.reducer;